<template>
  <div :id="id" class="row">
    <LmTextInput
      ref="inputFocus"
      :id="`label-${id}`"
      class="col-12 col-md-6"
      v-model="component.componentProps.label"
      @input="$emit('input', component)"
      label="Label"
      placeholder="Label"
    />

    <LmTextInput
        class="col-12 col-md-6"
        :id="id + 'nombre'"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        label="Nombre"
        placeholder="placeholder"
      />

      <LmTextInput
      ref="inputLabelGroup"
      :id="`label-group-${id}`"
      class="col-12 col-md-4"
      v-model="component.componentProps.labelGroup"
      @input="$emit('input', component)"
      label="Label group text"
      placeholder="Text"
    />

    <b-form-checkbox
      :id="id + 'addnumber'"
      class="col-12 col-md-2 checkbox-addnumber"
      v-model="component.componentProps.isLabelGroupNumber"
      @input="$emit('input', component)"
      name="checkbox-addnumber"
      :value="true"
      :unchecked-value="false"
    >
      Number
    </b-form-checkbox>

    <LmTextInput
      ref="inputTextButton"
      :id="`button-text-${id}`"
      class="col-12 col-md-6"
      v-model="component.componentProps.buttonText"
      @input="$emit('input', component)"
      label="Button text"
      placeholder="Text"
    />

    <div class="col-12">
      <hr class="w-100">
      <div class="mb-2"> </div>
      <draggable
        class="col-12"
        v-model="form.formElements"
        @start="drag=true"
        @end="drag=false"
        >
        <div v-for="(formElement, index) in form.formElements" :key="index" class="mt-3">
          <header  class="d-flex justify-content-between align-items-center bg-info text-white px-3">
          <font-awesome-icon class="handle mr-4 bars" icon="bars" />
          <h6 class="flex-grow-1 text-center" v-b-toggle="`collapse-repeat-${index}`">{{title(form.formElements[index])}}</h6>
          <div>
            <font-awesome-icon v-b-toggle="`collapse-repeat-${index}`" class="ml-4 clickable" icon="chevron-down" />
            <font-awesome-icon  class="ml-4 clickable" icon="trash" @click="removeFormElement(index)" />
          </div>
          </header>

          <b-collapse
           :id="`collapse-repeat-${index}`"
          class="border p-4"
          >
            <component
              :ref="`componentRef${index}`"
              :is="whatComponentBuilderUse(form.formElements[index].componentName)"
              :componentData="form.formElements[index]"
              :optionsChildOf="buildOptionsChildOf(form.formElements[index].formObjectToSendToServerProperty)"
              :visibilityDependOnConditions="form.formElements[index].visibilityDependOnConditions"
              :optionsSameAsValidation="{content: buildSameAsOptions(form.formElements)}"
              :validationsData="getValidation(form.formElements[index].formObjectToSendToServerProperty)"
              :options="lmSuperPowerSelectV2BuilderUiOptions"
              :isVisibleCondition="false"
              @validations-changes="onValidationsChange($event, index)"
            />
          </b-collapse>
        </div>
      </draggable>

      <LmSelect
      id="select-elements-0"
      label="Repeat field"
      class="mt-3"
      v-model="elementTypeOption"
      :options="getSelectorElementTypeOptions"
      />

      <LmButton
      buttonClass="btn-primary mb-1 "
      lmButtonWrapperClass="col-1"
      lmButtonRootWrapperClass="d-block col-1 p-0"
      :disabled="elementTypeOption === ''"
      type= 'button'
      :value="$t('Agregar')"
      @click.native="agregar"
      />

      <hr class="w-100 mt-4">
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :id="String(id)"
        :leftValueToCompareOptions="leftValueToCompareOptions"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
        @input="$emit('input', component)"
        />
    </div>

  </div>
</template>

<script>

import draggable from 'vuedraggable'

import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'
import LmSelect from '@/components/form/elements/LmSelect'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'

import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmSuperPowerSelectV2BuilderUi from '@/components/lmFormBuilderUi/LmSuperPowerSelectV2BuilderUi'
import LmButtonBuilderUi from '@/components/lmFormBuilderUi/LmButtonBuilderUi'
import LmDateBuilderUi from '@/components/lmFormBuilderUi/LmDateBuilderUi'
import LmDateTimeBuilderUi from '@/components/lmFormBuilderUi/LmDateTimeBuilderUi'
import LmLeaFletMapBuilderUi from '@/components/lmFormBuilderUi/LmLeaFletMapBuilderUi'
import LmHtmlContentBuilderUi from '@/components/lmFormBuilderUi/LmHtmlContentBuilderUi'
import LmFormPortalBuilderUi from '@/components/lmFormBuilderUi/LmFormPortalBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmCommentBuilderUi from '@/components/lmFormBuilderUi/LmCommentBuilderUi'
import LmCheckboxBuilderUi from '@/components/lmFormBuilderUi/LmCheckboxBuilderUi'
import lmFormBuilderUi from '@/mixins/lmFormBuilderUi.js'

export default {
  mixins: [lmFormElementsBuilderUiMixin, lmFormBuilderUi],
  components: {
    LmConditionalBuilderUi,
    LmSelect,
    LmTextInput,
    LmButton,
    draggable,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmEmailInputBuilderUi,
    LmFormSubtitlesBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmSelectBuilderUi,
    LmSuperPowerSelectV2BuilderUi,
    LmButtonBuilderUi,
    LmDateBuilderUi,
    LmDateTimeBuilderUi,
    LmLeaFletMapBuilderUi,
    LmHtmlContentBuilderUi,
    LmFormPortalBuilderUi,
    LmColorPickerBuilderUi,
    LmCommentBuilderUi,
    LmCheckboxBuilderUi
  },
  data () {
    return {
      component: {},
      elementTypeOption: '',
      listToRepeat: [],
      form: {
        formElements: []
      }
    }
  },
  computed: {
    getSelectorElementTypeOptions () {
      const newOptions = this.generator.selectorElementTypeOptions.content.filter(word => word.value !== 'LmRepeatFields')
      let selectorElementTypeOptions = Object.assign({}, this.generator.selectorElementTypeOptions)
      selectorElementTypeOptions.content = newOptions
      return selectorElementTypeOptions
    }
  },
  methods: {
    // Hago una sincronizacion entre los items del form y las validaciones
    onValidationsChange (event, index) {
      /*
        Envio la validacion de cada componente dentro de si mismo y no en un objeto por separado
        Esto evita tener que crear un generador de watchers para evitar la insercion erronea de propiedades
        Ejemplo: si escribo de name "dni", obtenia por cada letra un objeto con las validaciones
        d: {...}, dn: {...}, dni: {..}
      */
      for (const validation in event) {
        this.form.formElements[index].validations = event[validation]
      }
    },
    agregar () {
      let index = this.form.formElements.length

      // pasa nombre del componente y index
      this.selectorElementForm(this.elementTypeOption, index, 'LmRepeatFieldsBuilderUi')
    },
    title (component) {
      const componentLabel = component?.componentProps?.label
      const componentValue = component?.componentProps?.value
      const componentText = component?.componentProps?.text
      const { text } = this.generator.selectorElementTypeOptions.content.find(e => e.value === component?.componentName)
      let moreInfo = ''
      if (componentLabel) {
        moreInfo += ' - ' + componentLabel
      } else if (componentValue) {
        moreInfo += ' - ' + componentValue
      } else if (componentText) {
        moreInfo += ' - ' + componentText
      }
      return text + moreInfo
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    componentData () {
      // Escucha componentData que se envía de LmFormBuilderUi
      this.component = this.$refs.componentReff0.componentData.componentProps
    }

  },
  created () {
    // Si hay initialItems que se carguen independienemente si esta en modo edicion (a testear)
    // if (this.isOnEditMode && this.component.componentProps.initialItems.formElements) {
    if (this.component?.componentProps?.initialItems?.formElements) {
      this.form = this.component.componentProps.initialItems
    }
  }
}
</script>

<style lang="sass" scoped>
.checkbox-addnumber
  padding-top: 41px
</style>
